export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    td_abrev: item.td_abrev || "Abreviatura no disponible",
    td_descripcion: item.td_descripcion || "Descripción no disponible",
  }));
